import { render, staticRenderFns } from "./wty-canvas.vue?vue&type=template&id=d12f608e&scoped=true&"
import script from "./wty-canvas.vue?vue&type=script&lang=js&"
export * from "./wty-canvas.vue?vue&type=script&lang=js&"
import style0 from "./wty-canvas.vue?vue&type=style&index=0&id=d12f608e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d12f608e",
  null
  
)

export default component.exports